// hooks/useWakeServer.js
import { useState, useEffect } from "react";
import axios from "axios";

export function useWakeServer() {
  const [ready, setReady] = useState(false);
  const [warming, setWarming] = useState(false);

  useEffect(() => {
    const wake = async () => {
      const slowTimer = setTimeout(() => setWarming(true), 3000);

      let tentativas = 0;
      while (tentativas < 10) {
        try {
          await axios.get(
            "https://db-fluxoeasy-idq9.onrender.com/ping",
            { timeout: 8000 }
          );
          break; // servidor respondeu
        } catch {
          tentativas++;
          await new Promise(r => setTimeout(r, 3000));
        }
      }

      clearTimeout(slowTimer);
      setWarming(false);
      setReady(true);
    };

    wake();
  }, []);

  return { ready, warming };
}